import React from 'react'
import './Text.module.scss'

export type TextProps = {
    type?: string
    text?: string
    style?: any
    classes?: any
    children?: React.ReactNode
}

const Text = (props: TextProps) => {
    const { type, text, style, classes } = props

    const _type = type ? type : 'p'

    const _text = (type: string, text: string) => {
        switch (_type.toLowerCase()) {
            case 'span':
                return (
                    <span className={classes} style={style}>
                        {props.children ? props.children : <></>}
                    </span>
                )
            default:
                return (
                    <p className={classes} style={style}>
                        {props.children ? props.children : <></>}
                    </p>
                )
        }
    }

    return _text(type, text)
}

export default Text
